<template>
    <div class="views-content--visualizer-landing">

        <!-- Banner -->
        <banner-generic :data="data.hero" />

        <!--
        <div class="padding--lg">
            <element-text v-if="data.text" :data="data.text" />
        </div>
        -->

        <!-- Select house type section -->
        <section class="space-bottom--lg space--md">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" v-for="(house, index) in data.houses" :key="index" >
                        <a :href="house.visualiserlink" class="card card--profile"
                        data-category="Roof Visualiser" data-action="Click" :data-label="house.title"
                        >
                            <div class="card-image">
                                <img class="house-image" alt="house.title" v-lazy="house.image" >
                            </div>
                            <h4 class="medium">{{house.title}}</h4>
                        </a>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>

import {
    BannerGeneric,
    // ElementText
} from "../components";

export default {
    name: "v-visualiser-landing",
    components: {
        BannerGeneric,
        // ElementText
    },
    props: {
        data: {
            type: Object
        }
    },
    data () {
        return {}
    },
    mounted () {

    }
};
</script>

<style lang="scss" scoped>

.house-image{
    aspect-ratio: 16/9;
    object-fit: cover;
    z-index: 0;
}

.card--profile {
    display: block;
    margin-bottom: 3rem;
    
    .card-image {
        position: relative;

        &::before {
            content: "";
            display: block;
            position: absolute;
            z-index: 3;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: white;
            transition: all 300ms;
            opacity: 0;
        }
    }

    &:hover {
        .card-image {
            &::before {
                opacity: 0.2;
            }
        }
    }

    h4 {
        margin: 0;
    }
}

</style>

